<template>
  <v-toolbar dense elevation="0"  v-if="!hideHeader">
    <v-toolbar-title>
      <div class="title font-weight-regular">{{ title }}</div>
      <div v-if="subtitle" class="caption pt-1 text-truncate">
        {{ subtitle }}
      </div>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-row align="center" justify="end" >
      <v-col>
        <slot ></slot>
      </v-col>
      <v-col class="shrink">
        <v-btn
          v-if="!hideCreate" small 
          :icon="$vuetify.breakpoint.smAndDown"
          color="primary"
          @click="$emit('new')"
        >
          <span v-if="!$vuetify.breakpoint.smAndDown">New</span>
          <v-icon v-else>add</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- <v-layout row align-center justify-end>
      <v-flex shrink>
        <slot></slot>
      </v-flex>
      <v-flex shrink> </v-flex>
    </v-layout> -->
  </v-toolbar>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: ['hideHeader', 'dataCy', 'title', 'hideCreate', 'subtitle'],
  methods: {
    ...mapActions('register', ['setCustomer']),
    removeCustomer() {
      this.setCustomer(null);
    },
  },
};
</script>

<style scoped></style>
